import { ref, onMounted, getCurrentInstance } from 'vue';


export const useVerificationToken = () => {
  const verificationToken = ref<string>('');

  onMounted(() => {
    const input = document.querySelector<HTMLInputElement>('[name="__RequestVerificationToken"]');
    if (input !== null)
      verificationToken.value = input.value;
  });

  return { verificationToken };
};